/* eslint-disable @nx/workspace/no-restricted-imports-clone */
import { accordionAnatomy as parts } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  button: defineStyle({
    color: 'grey.900',
    fontSize: 'lg',
    fontWeight: 'bold',
    lineHeight: '1.5rem',
    letterSpacing: 'tight',
    _hover: {
      color: 'blue.500',
      background: 'none',
      fill: 'blue.500',
    },
  }),
  panel: defineStyle({
    letterSpacing: 'less-tight',
  }),
});

const variants = {
  'single-row': {
    panel: {
      mt: '2',
      py: '0',
    },
    container: {
      border: 'none',
      p: '6',
    },
  },
  group: {
    panel: {
      my: '2',
      py: '0',
    },
    container: {
      px: '6',
      py: '4',
      _last: {
        borderY: 'px',
        borderTop: 'unset',
        borderBottomColor: 'grey.100',
      },
    },
  },
  'group-compact': {
    button: {
      color: 'grey.600',
      fontSize: '14px',
      fontWeight: 'medium',
      letterSpacing: 'normal',
      lineHeight: 'short',
      px: '0',
      py: '1',
      gap: '1',
      _hover: {
        color: 'grey.900',
      },
    },
    panel: {
      color: 'grey.600',
      fontSize: '14px',
      p: '0',
      mt: '0.5',
      mb: '2',
      ml: '7',
    },
    container: {
      borderY: '0 none',
      p: '0',
    },
  },
};

export const styleConfig = defineMultiStyleConfig({
  baseStyle,
  variants,
  defaultProps: {
    variant: 'single-row',
  },
});
